import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const API = process.env.REACT_APP_API_URL;

const UserForgotPassword = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  // Add these states at the top
const [resendLoading, setResendLoading] = useState(false);
const [countdown, setCountdown] = useState(0);
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

 

  // STEP 1 - Send OTP
  const handleSendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await fetch(`${API}/api/auth/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    setLoading(false);

    if (!res.ok) {
      toast.error(data.error || "Failed to send OTP");
      return;
    }

    toast.success("OTP sent to your email!");
    setStep(2);
  };

  // STEP 2 - Verify OTP
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await fetch(`${API}/api/auth/verify-reset-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp }),
    });

    const data = await res.json();
    setLoading(false);

    if (!res.ok) {
      toast.error(data.error || "Invalid or expired OTP");
      return;
    }

    toast.success("OTP Verified!");
    setStep(3);
  };

  // STEP 3 - Reset Password
  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    setLoading(true);

    const res = await fetch(`${API}/api/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        newPassword: passwords.newPassword,
        confirmPassword: passwords.confirmPassword,
      }),
    });

    const data = await res.json();
    setLoading(false);

    if (!res.ok) {
      toast.error(data.error || "Reset failed");
      return;
    }

    toast.success("Password reset successful!");
    navigate("/auth?tab=register");
  };
// Resend OTP function
const handleResendOtp = async () => {
  if (!email) return;

  setResendLoading(true);

  try {
    const res = await fetch(`${API}/api/auth/resend-reset-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    setResendLoading(false);

    if (!res.ok) {
      toast.error(data.error || "Failed to resend OTP");
      return;
    }

    toast.success(data.message || "OTP resent successfully!");
    setCountdown(30); // 30 seconds cooldown before next resend
  } catch (err) {
    setResendLoading(false);
    toast.error("Something went wrong!");
  }
};

// Countdown timer effect
React.useEffect(() => {
  if (countdown <= 0) return;

  const timer = setInterval(() => {
    setCountdown((prev) => prev - 1);
  }, 1000);

  return () => clearInterval(timer);
}, [countdown]);
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-red-50/40 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-2xl shadow-xl shadow-red-100/40 border border-red-100 overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-red-200/30">
          <div className="px-8 sm:px-10 py-10 sm:py-12">
            {step === 1 && (
              <>
                <h2 className="text-3xl font-bold text-red-700 text-center mb-3">
                  Forgot Password
                </h2>
                <p className="text-gray-600 text-center mb-8 text-base">
                  Enter your email to receive OTP
                </p>

                <form onSubmit={handleSendOTP}>
                  <div className="mb-7">
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="sm:w-[360px] px-4 py-3.5 border-2 border-gray-300 rounded-xl text-base focus:outline-none focus:border-red-600 focus:shadow-lg focus:shadow-red-600/20 transition w-full"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="sm:w-[360px] w-full py-3.5 px-6 bg-red-600 text-white font-semibold text-base rounded-lg hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300/40 disabled:bg-red-300 disabled:cursor-not-allowed transition-all shadow-md shadow-red-200"
                  >
                    {loading ? "Sending..." : "Send OTP"}
                  </button>
                </form>
              </>
            )}

            {step === 2 && (
              <>
                <h2 className="text-3xl font-bold text-red-700 text-center mb-3">
                  Verify OTP
                </h2>
                <p className="text-gray-600 text-center mb-8 text-base">
                  Enter the OTP sent to Your mailID
                </p>

                <form onSubmit={handleVerifyOTP}>
                  <div className="mb-7">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      required
                      autoFocus
                      className="w-full px-5 py-3.5 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-red-500 focus:ring-4 focus:ring-red-200/40 transition-all placeholder:text-gray-400"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3.5 px-6 bg-red-600 text-white font-semibold text-base rounded-lg hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300/40 disabled:bg-red-300 disabled:cursor-not-allowed transition-all shadow-md shadow-red-200"
                  >
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>
                  <div className="mt-4 text-center">
  <button
    type="button"
    onClick={handleResendOtp}
    disabled={resendLoading || countdown > 0}
    className="bg-transparent text-red-600 text-sm underline disabled:text-gray-500 disabled:no-underline
               shadow-none hover:shadow-none focus:ring-0 focus:outline-none"
  >
    {resendLoading
      ? "Sending..."
      : countdown > 0
      ? `Resend OTP in ${countdown}s`
      : "Resend OTP"}
  </button>
</div>
                </form>
              </>
            )}

            {step === 3 && (
  <>
    <h2 className="text-3xl font-bold text-red-700 text-center mb-3">
      Set New Password
    </h2>
    <p className="text-gray-600 text-center mb-8 text-base">
      Choose a strong password
    </p>

    <form onSubmit={handleResetPassword}>
      <div className="relative mb-7">
        <input
          type={showNewPassword ? "text" : "password"}
          placeholder="New Password"
          value={passwords.newPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, newPassword: e.target.value })
          }
          required
          className="w-full px-5 py-3.5 pr-12 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-red-500 focus:ring-4 focus:ring-red-200/40 transition-all placeholder:text-gray-400"
        />
        <button
  type="button"
  onClick={() => setShowNewPassword(!showNewPassword)}
  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-600 cursor-pointer
             bg-transparent border-none p-0"
  aria-label={showNewPassword ? "Hide password" : "Show password"}
>
  {showNewPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
</button>
      </div>

      <div className="relative mb-7">
        <input
          type={showConfirmPassword ? "text" : "password"}
          placeholder="Confirm Password"
          value={passwords.confirmPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, confirmPassword: e.target.value })
          }
          required
          className="w-full px-5 py-3.5 pr-12 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-red-500 focus:ring-4 focus:ring-red-200/40 transition-all placeholder:text-gray-400"
        />
        <button
  type="button"
  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-600 cursor-pointer
             bg-transparent border-none p-0"
  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
>
  {showConfirmPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
</button>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full py-3.5 px-6 bg-red-600 text-white font-semibold text-base rounded-lg hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300/40 disabled:bg-red-300 disabled:cursor-not-allowed transition-all shadow-md shadow-red-200"
      >
        {loading ? "Resetting..." : "Reset Password"}
      </button>
    </form>
  </>
)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserForgotPassword;